function buildHashtagPayload(
	data: Partial<AdminHashtag>,
	imageReference: string | null,
	imageRemoved: boolean
): Record<string, unknown> {
	return {
		name: data.name ?? "",
		color: data.color ?? "",
		description: data.description ?? "",
		is_private: data.isPrivate ?? false,
		is_favourite: data.isFavourite ?? false,
		exclude_from_main_feed: data.excludeFromMainFeed ?? false,
		image_reference: imageReference ?? null,
		image_removed: imageRemoved
	};
}

export const adaptCreateHashtagPayload = (
	data: Partial<AdminHashtag>,
	imageReference: string | null
): Record<string, unknown> => {
	return buildHashtagPayload(data, imageReference, false);
};

export const adaptEditHashtagPayload = (
	data: Partial<AdminHashtag>,
	imageReference: string | null,
	imageRemoved = false
): Record<string, unknown> => {
	return buildHashtagPayload(data, imageReference, imageRemoved);
};
